import React from 'react';
import { Grid, TextField, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import type { IndianMarketCharges } from '../../../../../models/PlanExecutionTypes';

interface Props {
  charges: IndianMarketCharges;
  onChange: (charges: IndianMarketCharges) => void;
  disabled?: boolean;
}

const FIELDS: { key: keyof IndianMarketCharges; label: string; hint?: string }[] = [
  { key: 'stt', label: 'STT', hint: 'Securities Transaction Tax (0.1% delivery)' },
  { key: 'brokerage', label: 'Brokerage' },
  { key: 'gstOnBrokerage', label: 'GST on brokerage', hint: 'Typically 18%' },
  { key: 'exchangeTxnCharges', label: 'Exchange txn charges' },
  { key: 'sebiTurnoverFees', label: 'SEBI turnover fees' },
  { key: 'stampDuty', label: 'Stamp duty', hint: 'Buy side only' },
];

const IndianMarketChargesFields: React.FC<Props> = ({ charges, onChange, disabled }) => (
  <Accordion variant="outlined" disableGutters sx={{ bgcolor: 'transparent' }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="caption" color="text.secondary">
        Indian market charges & taxes (STT, brokerage, GST, stamp duty…)
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Grid container spacing={1.5}>
        {FIELDS.map(({ key, label, hint }) => (
          <Grid item xs={12} sm={6} md={4} key={key}>
            <TextField
              label={label}
              type="number"
              size="small"
              fullWidth
              disabled={disabled}
              value={charges[key] || ''}
              onChange={(e) =>
                onChange({ ...charges, [key]: e.target.value ? Number(e.target.value) : 0 })
              }
              helperText={hint}
              inputProps={{ min: 0, step: 0.01 }}
            />
          </Grid>
        ))}
      </Grid>
    </AccordionDetails>
  </Accordion>
);

export default IndianMarketChargesFields;
